import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { RootState } from '@features/store';

export type PreferredValuesState = {
    preferredOperator: string | number | null;
    preferredWorksite: string | number | null;
};

const initialPreferredValuesState: PreferredValuesState = {
    preferredOperator: null,
    preferredWorksite: null
};

export const preferredValuesSlice = createSlice({
    name: 'preferredValues',
    initialState: initialPreferredValuesState,
    reducers: {
        setPreferredValues: (state, action: PayloadAction<PreferredValuesState>) => {
            state.preferredOperator = action.payload.preferredOperator;
            state.preferredWorksite = action.payload.preferredWorksite;
        }
    }
});
export const getPreferredOperator = (state: RootState) => state.preferredValues.preferredOperator;
export const getPreferredWorksite = (state: RootState) => state.preferredValues.preferredWorksite;

export const { setPreferredValues } = preferredValuesSlice.actions;

export default preferredValuesSlice.reducer;
